import React from 'react';

import {
  PARAGRAPH_VIEW_MODE_DEFAULT,
} from '../../../config/constants';

import TextWithImageDefault from './Default';
import TextWithImageFullscreen from './Fullscreen';
import TextWithImageHomepage from './Homepage';

const componentMapping = {
  default: TextWithImageDefault,
  fullscreen: TextWithImageFullscreen,
  homepage: TextWithImageHomepage,
};

import './style.scss';

const ParagraphTextWithImage = ({ entity, viewMode = PARAGRAPH_VIEW_MODE_DEFAULT, lazyload = true }) => {

  const UsableComponent = componentMapping[viewMode];

  return (
    <UsableComponent entity={entity} lazyload={lazyload} />
  );
};

export default ParagraphTextWithImage;
